<template>
    <button
        v-cloak
        :disabled="isSending"
        class="btn btn-sm"
        :class="{
            'btn-primary': ! isSending,
            'btn-outline-primary': isSending,
        }"
        @click.prevent="submit"
    >
        <font-awesome-icon
          v-if="isSending"
          icon="fa-solid fa-spinner"
          class="me-1"
          spin
        />

        <slot></slot>
    </button>
</template>

<script>
import Swal from "sweetalert2";
import { EventBus } from "../EventBus.js";

export default {
  props: {
    endpoint: {
      type: String,
      required: true,
    },
    method: {
      type: String,
      required: false,
      default: "post",
    },
    body: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      status: "pending",
    };
  },

  computed: {
    isSending() {
      return (this.status === "sending");
    },
    isSuccess() {
      return (this.status === "success");
    },
  },

  methods: {
    submit() {
      Swal.fire({
        title: "Are you sure?",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      })
        .then((result) => {
          if (result.value) {
            this.status = "sending";

            // send AJAX request
            axios.post(this.endpoint, {
              _method: this.method,
              ...this.body,
            })
              .then((response) => {
                this.status = "success";

                // emit event to bus
                EventBus.$emit("actioned", response.data);

                // emit event to parent
                this.$emit("actioned", response.data);
              })
              .catch((error) => {
                this.status = "pending";

                Swal.fire({
                  title: "Please try again.",
                  type: "warning",
                  confirmButtonColor: "#37991D",
                  confirmButtonText: "OK",
                });

                // emit event to parent
                this.$emit("failed", error);
              });
          }
        });
    },
  },
};
</script>
